/* Visual motion only. Native selection, pricing and cart handlers remain authoritative. */
(() => {
 'use strict';
 const initialize=(scope=document)=>{
  scope.querySelectorAll('.mk-setup-stage').forEach(host=>{
   if(host.dataset.stageMotionReady)return;host.dataset.stageMotionReady='true';
   const reduced=matchMedia('(prefers-reduced-motion: reduce)'),abort=new AbortController();
   const records=new Map(),textRecords=new Map();let frame=0;
   host.querySelectorAll('.mk-stage-slot [data-quote-line]').forEach(line=>{
    records.set(line,{visible:!line.hidden,snapshot:line.cloneNode(true),animation:null,ghost:null});
   });
   const textElements=[host.querySelector('[data-bundle-total]'),host.querySelector('[data-bundle-count]'),host.querySelector('[data-quote-saving]')].filter(Boolean);
   textElements.forEach(element=>textRecords.set(element,{value:element.textContent,animation:null}));
   const clearMotion=record=>{record.animation?.cancel();record.ghost?.remove();record.animation=null;record.ghost=null;};
   const renderLine=(line,record,initial=false)=>{
    const slot=line.closest('.mk-stage-slot'),visible=!line.hidden;
    slot.dataset.filled=String(visible);
    const placeholder=slot.querySelector('.mk-stage-placeholder');
    if(placeholder){placeholder.setAttribute('aria-hidden',String(visible));placeholder.inert=visible;}
    if(initial || record.visible===visible){if(visible)record.snapshot=line.cloneNode(true);record.visible=visible;return;}
    const opacity=record.animation?Number(getComputedStyle(record.ghost || line).opacity):(visible?0:1);
    clearMotion(record);
    // Replace the native entrance flourish only on this component's own summary line.
    line.getAnimations().forEach(animation=>animation.cancel());
    record.visible=visible;
    if(reduced.matches){if(visible)record.snapshot=line.cloneNode(true);return;}
    if(visible){
     const animation=line.animate([{opacity,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'cubic-bezier(.2,.7,.2,1)'});
     record.animation=animation;record.snapshot=line.cloneNode(true);
     animation.onfinish=()=>{if(record.animation===animation)record.animation=null;};
    }else{
     // The removed real line is already hidden. Its inert copy provides only the exit visual.
     const ghost=record.snapshot.cloneNode(true);ghost.hidden=false;
     ghost.removeAttribute('data-quote-line');ghost.removeAttribute('data-product-id');
     ghost.classList.add('mk-stage-ghost');ghost.setAttribute('aria-hidden','true');ghost.inert=true;
     ghost.querySelectorAll('[id]').forEach(element=>element.removeAttribute('id'));
     slot.append(ghost);record.ghost=ghost;
     const animation=ghost.animate([{opacity,transform:'translateY(0)'},{opacity:0,transform:'translateY(-3px)'}],{duration:260,easing:'cubic-bezier(.2,.7,.2,1)'});
     record.animation=animation;
     animation.onfinish=()=>{ghost.remove();if(record.animation===animation){record.animation=null;record.ghost=null;}};
    }
   };
   const render=()=>{
    frame=0;if(!host.isConnected){observer.disconnect();return;}
    records.forEach((record,line)=>renderLine(line,record));
    textRecords.forEach((record,element)=>{
     const value=element.textContent;if(record.value===value)return;record.value=value;
     const opacity=record.animation?Number(getComputedStyle(element).opacity):.4;
     record.animation?.cancel();record.animation=null;if(reduced.matches)return;
     const animation=element.animate([{opacity},{opacity:1}],{duration:260,easing:'cubic-bezier(.2,.7,.2,1)'});
     record.animation=animation;animation.onfinish=()=>{if(record.animation===animation)record.animation=null;};
    });
   };
   records.forEach((record,line)=>renderLine(line,record,true));
   const observer=new MutationObserver(()=>{if(!frame)frame=requestAnimationFrame(render);});
   observer.observe(host,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden']});
   reduced.addEventListener('change',()=>{if(reduced.matches){records.forEach(clearMotion);textRecords.forEach(record=>{record.animation?.cancel();record.animation=null;});}},{signal:abort.signal});
   document.addEventListener('shopify:section:unload',event=>{
    if(!event.target.contains(host))return;
    observer.disconnect();cancelAnimationFrame(frame);records.forEach(clearMotion);textRecords.forEach(record=>record.animation?.cancel());abort.abort();
   },{signal:abort.signal});
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
